import React from "react";
import RotaFreteForm from "./RotaFreteForm";

function GridBody({ onClose, onSaved } = {}) {
  return <RotaFreteForm mode="create" onClose={onClose} onSaved={onSaved} />;
}

export default GridBody;